import React, { useEffect, useState } from 'react';
import Styles from './credit-card-styles.scss';
import { ExpensesModal, Table, ButtonKVBase, HeaderMenu, TabHeader } from '@/presentation/components';
import { IconDollar } from '@/presentation/components/icons';
import PayBillModal from '../components/pay-bill-modal/paybill-modal';
import CreditCardComponent from './components/credit-card-component/credit-card-component';
import CreditSummary from './components/credit-summary/credit-summary';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useNavigate } from 'react-router-dom';
import useFakeCreditCard from '@/presentation/hooks/use-fake-credit-card';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import { parseNumberMoney } from '@/presentation/utils/number-utils';
import useTransactionTable from '../checking-account/hooks/useTransactionTable';
import { useRecoilState } from 'recoil';
import { transactionTableCCState } from '../checking-account/components/atoms';
import DataNotFoundComp from '../../all-students/components/data-not-found';
import { useChartCreditCard } from '../hooks/use-chart-credit-card';
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const CreditCard = ({ virtualTransactions, validationPayBill, manageVirtualTransactions }) => {
    const [openModal, setOpenModal] = useState(false);
    const { user } = useUserSesssion();
    const navigate = useNavigate();
    const { chartData, total, loading } = useChartCreditCard({ virtualTransactions });
    const { cardNumber, expiry } = useFakeCreditCard();
    const { creditCardAccount } = useStudentAccounts(false);
    const [state, setState] = useRecoilState(transactionTableCCState);
    const { columns, columnsWithoutSort, getTransactionsPaginated, renderCellByType } = useTransactionTable({
        manageVirtualTransactions,
        virtualAccountIds: [creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.id],
        mainTableState: transactionTableCCState
    });
    const calculateAvailableCredit = (creditCardAccount) => {
        const availableCredit = Number(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.creditLimit) - Number(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance);
        if (isNaN(availableCredit))
            return 0;
        return availableCredit;
    };
    // fake credit score for now
    const [creditScore, setCreditScore] = useState(0);
    useEffect(() => {
        const fakeCreditScore = getRandomNumber(300, 850);
        setCreditScore(fakeCreditScore);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.mainWrap },
            React.createElement("div", { style: { padding: '1rem 0rem 0rem 2rem' } },
                React.createElement(HeaderMenu, { title1: "My wallet", title2: "Credit Card", onBack: () => navigate(`/student-dashboard/my-wallet/overview`) })),
            React.createElement("div", { className: Styles.creditCardContainer },
                React.createElement("div", { className: Styles.checking },
                    React.createElement("div", { className: Styles.headerWrap },
                        React.createElement("div", { className: Styles.title }, "Credit Card"),
                        React.createElement("div", { className: Styles.payBillBtn },
                            React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", leftIcon: React.createElement(IconDollar, { color: "white" }), onClick: () => setOpenModal(true) }, "Pay Bill"))),
                    React.createElement("div", { style: { width: '100%' } },
                        React.createElement(CreditCardComponent, { number: cardNumber, name: `${user.firstName + ' ' + user.lastName}`, expiry: `${expiry === null || expiry === void 0 ? void 0 : expiry.month}/${expiry === null || expiry === void 0 ? void 0 : expiry.year}`, limit: `${parseNumberMoney(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.creditLimit)} KV` })),
                    React.createElement("div", { style: { width: '100%' } },
                        React.createElement(CreditSummary, { balance: `${parseNumberMoney(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance)} KV`, availableCredit: `${parseNumberMoney(calculateAvailableCredit(creditCardAccount))} KV`, creditScore: creditScore, statementDate: "05/31/2024", minimumPayment: `${parseNumberMoney(parseFloat(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance) * 0.03)} KV`, interestRate: "15" }))),
                React.createElement(PayBillModal, { openModal: openModal, setOpenModal: setOpenModal, validationPayBill: validationPayBill, manageVirtualTransactions: manageVirtualTransactions, accountToParam: 'Credit Card' }),
                React.createElement("div", { className: Styles.chart },
                    React.createElement(ExpensesModal, { items: chartData, loading: loading, total: total, chartWidth: "100%", chartHeight: "100%" }))),
            React.createElement("div", { className: Styles.table },
                React.createElement(TabHeader, { title: "Transaction History" }),
                React.createElement(Table, { columns: columns, data: state.transactions.data, 
                    // dataNotFound={state.dataNotFound}
                    DataNotFoundComponent: () => {
                        return React.createElement(DataNotFoundComp, null);
                    }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                        total: state.transactions.total,
                        page: state.transactions.page,
                        count: state.transactions.count,
                        pageCount: state.transactions.pageCount
                    }, fetchData: (pagination, sort) => {
                        getTransactionsPaginated(state.filters, pagination, sort);
                    }, filters: state.filters, loading: state.isTableLoading })),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)),
        React.createElement("br", null),
        React.createElement("br", null)));
};
export default CreditCard;
